// encryptionKey.js
const encryptionKey = 'EncryptionKeyHerath';

// export default encryptionKey;
export { encryptionKey }
